import { JsonProperty, Serializable } from "typescript-json-serializer";
import { AttributeDto } from "./AttributeDto";
@Serializable()
export class AttributeValueDto {
    @JsonProperty()
    id: number;

    @JsonProperty()
    clazz: string;
        
    @JsonProperty()
    modifiedDate: number;
        
    @JsonProperty()
    modifiedBy: string;
        
    @JsonProperty()
    value?: string;
        
    @JsonProperty()
    optionIds?: string;
        
    @JsonProperty()
    attribute: AttributeDto;
        
    @JsonProperty()
    attributeId: number;
        
    @JsonProperty()
    productId: number;
        
    @JsonProperty()
    multilingualKey: string;
  }